import * as React from 'react';
import { __ } from '../../helpers/TranslationService';
import * as Cookie from '../../helpers/cookie';
import { CrossIcon } from '../Icons/CrossIcon';
import { eventTracker } from '../../helpers/EventTracker/EventTracker';

interface IProps {
    isVisible: boolean;
    email: string;
    signUp: Function;
    portalId: string;
}

interface IState {
    isVisible: boolean;
}

export class NewsletterButton extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: this.props.isVisible,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isVisible !== this.props.isVisible) {
            this.setState({
                isVisible: this.props.isVisible,
            });
        }
        this.trackNewsletterSubscriptionLayer();
    }

    submitNewsletterSubscription = () => {
        this.props
            .signUp(this.props.email, `${this.props.portalId} g-onetap`)
            .then(() => {
                Cookie.removeCookie('oneTapEmail');
                Cookie.writeCookie('DLhasLead', 'true', 30);
                Cookie.writeSessionCookie('isSignedUpForNewsletter', 'true');
                this.setState({
                    isVisible: false,
                });
                eventTracker.track({
                    category: 'Google One Tap',
                    action: 'Newsletter subscription',
                    label: window.location.href,
                    event: 'click',
                });
            })
            .catch(() => {
                Cookie.removeCookie('oneTapEmail');
                this.setState({
                    isVisible: false,
                });
            });
    };

    close = () => {
        Cookie.removeCookie('oneTapEmail');
        this.setState({
            isVisible: false,
        });
    };

    trackNewsletterSubscriptionLayer = () => {
        if (this.state.isVisible) {
            eventTracker.track({
                category: 'Google One Tap',
                action: 'Newsletter layer show',
                label: window.location.href,
                event: 'click',
            });
        }
    };

    render() {
        return (
            this.state.isVisible &&
            !Cookie.readCookie('isSignedUpForNewsletter') && (
                <div className="google-one-tap">
                    <span className="google-one-tap--closeButtonWrapper" onClick={this.close}>
                        <CrossIcon width={15} height={15} className="google-one-tap--closeButton" />
                    </span>
                    <div className="google-one-tap--disclaimer">
                        {__(
                            'Login erfolgreich. Jetzt "OK" klicken und Angebote per E-Mail freischalten.',
                            'dreamlines',
                        )}
                    </div>
                    <div
                        className="google-one-tap--button"
                        onClick={this.submitNewsletterSubscription}
                    >
                        {__('OK', 'dreamlines')}
                    </div>
                </div>
            )
        );
    }
}
